import { ContentContainer } from '@gorila-shared-ui/components';
import { useState } from 'react';
import { CommsReportFiltersBar } from '../../reports/CommsReportFiltersBar';
import { CommsReportOfflineList } from '../../reports/CommsReportOfflineList';

export function CommsReportOfflinePage() {
  const [reloadPage, setReloadPage] = useState(false);

  return (
    <ContentContainer>
      <CommsReportFiltersBar onReloadPage={() => setReloadPage(!reloadPage)} />
      <CommsReportOfflineList reloadPage={reloadPage} />
    </ContentContainer>
  );
}
